import React from 'react'
import styles from './LbHowItWorks.module.css'
import { motion } from 'framer-motion'
import { FaLink, FaCode, FaRocket } from 'react-icons/fa'

const steps = [
    {
        icon: <FaLink />,
        title: '1. Generate Token',
        desc: 'Create your encrypted LeadBridge™ token inside the CRM with details like domain, vendor, and form identifier.'
    },
    {
        icon: <FaCode />,
        title: '2. Embed the Snippet',
        desc: 'Just copy the auto-generated script or PHP snippet and add it to your website’s form.'
    },
    {
        icon: <FaRocket />,
        title: '3. Leads Start Flowing',
        desc: 'As soon as the user hits submit, the data securely arrives in your CRM in real-time.'
    }
]

const LbHowItWorks = () => {
    return (
        <section className={styles.howItWorks}>
            <div className={styles.container}>
                <motion.h2
                    className={styles.heading}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    How <span className={styles.highlight}>LeadBridge™</span> Works
                </motion.h2>

                <div className={styles.stepsGrid}>
                    {steps.map((step, i) => (
                        <motion.div
                            key={i}
                            className={styles.stepCard}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: i * 0.2 }}
                            viewport={{ once: true }}
                        >
                            <div className={styles.icon}>{step.icon}</div>
                            <h3>{step.title}</h3>
                            <p>{step.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default LbHowItWorks
